import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { fetchProfile, useAppStore } from "@/store/appStore";

/**
 * Subscribe to Supabase auth state changes and keep our local store
 * (session + profile) in sync. Mount once at the app root.
 */
export const useAuthBootstrap = () => {
  const setSession = useAppStore((s) => s.setSession);
  const setProfile = useAppStore((s) => s.setProfile);
  const setAuthReady = useAppStore((s) => s.setAuthReady);

  useEffect(() => {
    // 1. Subscribe FIRST so we never miss an event.
    const { data: subscription } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session);
        if (session?.user) {
          // Defer DB call to avoid deadlocks inside the auth callback.
          setTimeout(() => {
            fetchProfile(session.user.id).then(setProfile);
          }, 0);
        } else {
          setProfile(null);
        }
      },
    );

    // 2. THEN load existing session.
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session?.user) {
        fetchProfile(session.user.id).then(setProfile);
      }
      setAuthReady(true);
    });

    return () => {
      subscription.subscription.unsubscribe();
    };
  }, [setSession, setProfile, setAuthReady]);
};
